import axios from "axios";
import {API_BASE_URL, BASE_URL} from "./consts";

const bases = {
	gotoviy: `${API_BASE_URL}/gotoviy`,
	legacy: `${BASE_URL}/api`,
};

const getHeaders = (auth = true) => {
	const headers = {"Content-Type": "application/json"};
	if (auth) {
		const token = sessionStorage.getItem("token");
		if (token) headers.Authorization = `Bearer ${token}`;
	}
	return headers;
};

const request = async (method, base, path, {data, params, auth} = {}) => {
	const response = await axios({
		method,
		url: `${bases[base]}${path}`,
		headers: getHeaders(auth),
		data,
		params,
	});
	return response.data;
};

export const http = {
	get: (base, path, opts) => request("GET", base, path, opts),
	post: (base, path, opts) => request("POST", base, path, opts),
	put: (base, path, opts) => request("PUT", base, path, opts),
	patch: (base, path, opts) => request("PATCH", base, path, opts),
	delete: (base, path, opts) => request("DELETE", base, path, opts),
};
